import { Spinner } from 'react-bootstrap';

function BasicSpinner(props) {

  return (
    <div
      style={{
        width: "100%",
        textAlign: "center"
      }}
    >
      <Spinner animation="border" role="status" {...props}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

export { BasicSpinner };
